<template>
  <div class="home-page">
    <!-- 首页横幅 -->
    <section class="banner">
      <div class="banner-item">
        <img
          src="https://picsum.photos/id/237/1920/500"
          alt="专业医疗健康服务"
          class="banner-img" />
        <div class="banner-text">
          <h2>专业医疗健康服务</h2>
          <p>呵护您的健康，守护您的幸福生活</p>
          <el-button type="primary" size="large" class="banner-btn"
            >立即咨询</el-button
          >
        </div>
      </div>
    </section>

    <!-- 服务板块 -->
    <section class="services">
      <div class="container">
        <div
          class="service-item"
          v-for="(service, index) in services"
          :key="index">
          <div
            class="service-content"
            :class="index % 2 === 0 ? 'left' : 'right'">
            <div class="service-info">
              <h3>{{ service.title }}</h3>
              <p>{{ service.description }}</p>
              <el-button type="primary" size="medium">{{
                service.buttonText
              }}</el-button>
            </div>
            <div class="service-image">
              <img
                :src="service.image"
                :alt="service.title"
                class="service-img" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 成功客户案例 -->
    <section class="cases">
      <div class="container">
        <h2 class="section-title">成功客户案例展示</h2>
        <div class="cases-grid">
          <div
            class="case-item"
            v-for="(caseItem, index) in cases"
            :key="index">
            <img :src="caseItem.image" :alt="caseItem.title" class="case-img" />
          </div>
        </div>
        <div class="cases-more">
          <el-button type="primary" size="medium">查看更多</el-button>
        </div>
      </div>
    </section>

    <!-- 客户合作伙伴 -->
    <section class="partners">
      <div class="container">
        <h2 class="section-title">合作伙伴</h2>
        <div class="partners-grid">
          <div
            class="partner-item"
            v-for="(partner, index) in partners"
            :key="index">
            <img :src="partner.image" alt="合作伙伴" class="partner-img" />
          </div>
        </div>
      </div>
    </section>

    <!-- 产品服务 -->
    <section class="products">
      <div class="container">
        <h2 class="section-title">
          <router-link to="/products" style="color: #333; text-decoration: none"
            >产品服务</router-link
          >
        </h2>
        <div class="products-grid">
          <div
            class="product-item"
            v-for="(product, index) in products"
            :key="index">
            <div class="product-icon">
              <img
                :src="`https://picsum.photos/id/${index + 10}/100/100`"
                :alt="product.title"
                style="width: 60px; height: 60px; border-radius: 50%" />
            </div>
            <h3>{{ product.title }}</h3>
            <p>{{ product.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户案例 -->
    <section class="cases">
      <div class="container">
        <h2 class="section-title">客户案例</h2>
        <div class="case-list">
          <el-card
            class="case-card"
            v-for="(caseItem, index) in cases"
            :key="index">
            <div class="case-content">
              <h3>{{ caseItem.title }}</h3>
              <p>{{ caseItem.description }}</p>
              <el-button type="text">查看详情</el-button>
            </div>
          </el-card>
        </div>
      </div>
    </section>

    <!-- 底部横幅 -->
    <section class="bottom-banner">
      <div class="container">
        <div class="banner-content">
          <h3>您的健康，我们的责任</h3>
          <p>专业医疗团队，先进设备，为您的健康保驾护航</p>
          <el-button type="primary" size="large">立即咨询</el-button>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="contact">
      <div class="container">
        <h2 class="section-title">
          <router-link to="/contact" style="color: #333; text-decoration: none"
            >联系我们</router-link
          >
        </h2>
        <div class="contact-content">
          <div class="contact-info">
            <div class="info-item">
              <i class="el-icon-location"></i>
              <span>诊所地址：北京市海淀区医疗健康产业园</span>
            </div>
            <div class="info-item">
              <i class="el-icon-phone"></i>
              <span>预约电话：400-888-9999</span>
            </div>
            <div class="info-item">
              <i class="el-icon-message"></i>
              <span>电子邮箱：service@healthcare.com</span>
            </div>
            <div class="info-item">
              <i class="el-icon-time"></i>
              <span>营业时间：周一至周日 8:00-20:00</span>
            </div>
          </div>
          <el-form :model="contactForm" class="contact-form">
            <el-form-item label="姓名">
              <el-input
                v-model="contactForm.name"
                placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="电话">
              <el-input
                v-model="contactForm.phone"
                placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="留言">
              <el-input
                type="textarea"
                v-model="contactForm.message"
                placeholder="请输入留言内容"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitContact">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      services: [
        {
          title: "健康体检服务",
          description:
            "提供全面的健康体检套餐，包括常规体检、专项体检和高端定制体检，由经验丰富的医疗团队提供专业指导和解读。",
          buttonText: "了解更多",
          image: "https://picsum.photos/id/96/600/400",
        },
        {
          title: "远程医疗咨询",
          description:
            "足不出户即可享受专业医生的健康咨询服务，通过视频、电话等方式解答健康问题，提供诊疗建议。",
          buttonText: "了解更多",
          image: "https://picsum.photos/id/401/600/400",
        },
        {
          title: "慢病管理计划",
          description:
            "为高血压、糖尿病等慢性疾病患者提供个性化的健康管理方案，定期监测、用药指导和生活方式干预。",
          buttonText: "了解更多",
          image: "https://picsum.photos/id/447/600/400",
        },
      ],
      cases: [
        {
          title: "企业员工体检项目",
          description:
            "为某大型企业提供千人规模的员工体检服务，提前发现健康风险，提高员工健康水平。",
          image: "https://picsum.photos/id/365/300/200",
        },
        {
          title: "社区健康管理计划",
          description:
            "在多个社区开展健康管理计划，提供免费健康咨询和定期体检，受到社区居民好评。",
          image: "https://picsum.photos/id/338/300/200",
        },
        {
          title: "远程医疗援助项目",
          description:
            "为偏远地区提供远程医疗援助，解决医疗资源不足问题，提高医疗服务可及性。",
          image: "https://picsum.photos/id/25/300/200",
        },
      ],
      partners: [
        {
          image: "https://picsum.photos/id/244/200/100",
        },
        {
          image: "https://picsum.photos/id/245/200/100",
        },
        {
          image: "https://picsum.photos/id/246/200/100",
        },
        {
          image: "https://picsum.photos/id/247/200/100",
        },
        {
          image: "https://picsum.photos/id/248/200/100",
        },
        {
          image: "https://picsum.photos/id/249/200/100",
        },
      ],
      products: [
        {
          title: "精准体检套餐",
          description:
            "根据不同年龄段和健康需求定制的全面体检方案，采用先进设备和技术。",
        },
        {
          title: "健康管理APP",
          description:
            "智能健康管理平台，记录健康数据，提供个性化健康建议和用药提醒。",
        },
        {
          title: "专家门诊预约",
          description:
            "提供三甲医院专家门诊预约服务，缩短就医等待时间，提高就医效率。",
        },
      ],
      contactForm: {
        name: "",
        phone: "",
        message: "",
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    submitContact() {
      this.$message.success("提交成功！");
      this.contactForm = { name: "", phone: "", message: "" };
    },
  },
};
</script>

<style scoped lang="less">
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 60px;
  position: relative;
  &::after {
    content: "";
    display: block;
    width: 60px;
    height: 4px;
    background-color: #1890ff;
    margin: 15px auto 0;
  }
}

/* Banner样式 */
.banner {
  margin-bottom: 80px;
  .banner-item {
    position: relative;
    height: 500px;
    overflow: hidden;
    .banner-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .banner-text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: #fff;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
      h2 {
        font-size: 48px;
        margin-bottom: 20px;
      }
      p {
        font-size: 20px;
        margin-bottom: 30px;
      }
      .banner-btn {
        font-size: 16px;
        padding: 12px 36px;
      }
    }
  }
}

/* 服务板块样式 */
.services {
  margin-bottom: 100px;
  .service-item {
    margin-bottom: 80px;
    &:last-child {
      margin-bottom: 0;
    }
    .service-content {
      display: flex;
      align-items: center;
      gap: 60px;
      &.left {
        flex-direction: row;
      }
      &.right {
        flex-direction: row-reverse;
      }
      .service-info {
        flex: 1;
        h3 {
          font-size: 28px;
          margin-bottom: 20px;
          color: #333;
        }
        p {
          font-size: 16px;
          line-height: 1.8;
          color: #666;
          margin-bottom: 30px;
        }
      }
      .service-image {
        flex: 1;
        .service-img {
          width: 100%;
          height: auto;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
}

/* 案例展示样式 */
.cases {
  margin-bottom: 100px;
  .cases-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    .case-item {
      .case-img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
    }
  }
  .cases-more {
    text-align: center;
    margin-top: 40px;
  }
}

/* 合作伙伴样式 */
.partners {
  background-color: #f5f5f5;
  padding: 80px 0;
  margin-bottom: 60px;
  .partners-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    .partner-item {
      background-color: #fff;
      padding: 20px;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      .partner-img {
        max-width: 80%;
        max-height: 80%;
        object-fit: contain;
      }
    }
  }
}

/* 产品服务样式 */
.products {
  margin-bottom: 100px;
  .products-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    .product-item {
      text-align: center;
      padding: 30px;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transition: transform 0.3s, box-shadow 0.3s;
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
      }
      .product-icon {
        margin-bottom: 20px;
      }
      h3 {
        font-size: 20px;
        margin-bottom: 15px;
        color: #333;
      }
      p {
        font-size: 14px;
        color: #666;
        line-height: 1.6;
      }
    }
  }
}

/* 底部横幅样式 */
.bottom-banner {
  background-color: #333;
  padding: 60px 0;
  color: #fff;
  margin-bottom: 60px;
  .banner-content {
    text-align: center;
    h3 {
      font-size: 32px;
      margin-bottom: 20px;
      color: #fff;
    }
    p {
      font-size: 18px;
      margin-bottom: 30px;
      opacity: 0.9;
    }
  }
}

/* 联系我们样式 */
.contact {
  margin-bottom: 80px;
  .contact-content {
    display: flex;
    gap: 60px;
    .contact-info {
      flex: 1;
      .info-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        i {
          font-size: 24px;
          color: #1890ff;
          margin-right: 15px;
        }
        span {
          font-size: 16px;
          color: #666;
        }
      }
    }
    .contact-form {
      flex: 1;
    }
  }
}
</style>
